import bundle$3 from './de/refront-components.js';
import bundle from './en/refront-components.js';
import bundle$2 from './es/refront-components.js';
import bundle$1 from './fr/refront-components.js';
import bundle$6 from './hu/refront-components.js';
import bundle$4 from './it/refront-components.js';
import bundle$5 from './nl/refront-components.js';
import bundle$9 from './pl/refront-components.js';
import bundle$7 from './pt/refront-components.js';
import bundle$8 from './ro/refront-components.js';

var languages = {
    en: {
        "refront-components": bundle
    },
    fr: {
        "refront-components": bundle$1
    },
    es: {
        "refront-components": bundle$2
    },
    de: {
        "refront-components": bundle$3
    },
    it: {
        "refront-components": bundle$4
    },
    nl: {
        "refront-components": bundle$5
    },
    hu: {
        "refront-components": bundle$6
    },
    pt: {
        "refront-components": bundle$7
    },
    ro: {
        "refront-components": bundle$8
    },
    pl: {
        "refront-components": bundle$9
    }
};
/**
 * All the namespaces used in the library.
 */
var translationNamespaces = ["refront-components"];

export { languages as default, translationNamespaces };
//# sourceMappingURL=index.js.map
